import { enClientPortalValuationOverviewPageCommon } from './ValuationOverview/ValuationOverview'

export const enClientPortalValuationOverviewCommon = {
    valuationOverview: enClientPortalValuationOverviewPageCommon,
}
